import { toast } from "sonner";
import { authAxios } from "../utils/axiosConfig";
import { useDispatch } from "react-redux";
import { fetchUsers } from "../redux/usersSlice";
import "../styles/ModalDeleteConfirmation.css";

const ModalDeleteUser = ({ userId, email, showDeleteModal }) => {
	const dispatch = useDispatch()
	
	const closeModal = () => {
		showDeleteModal(false)
	};

	const confirmDelete = async () => {
		if (!userId) {
			toast.error("User ID is missing!");
			return;
		}
		// console.log("USER: ", userId, email)
		try {
			// console.log("User with ID:", userId, "is being deleted...");
			// const response = userId;
			const response = await authAxios.delete(`/api/users/${userId}`);
	
			dispatch(fetchUsers());
			toast.success(`${email} has been deleted.`);
			// console.log(response.data);
			
		} catch (error) {
			// console.error("Failed to delete user:", error);
			toast.error("Failed to delete user. Please try again.");
		}
	};

	return (
		<div className="modal-overlay">
			<div className="modal">
				<h2>Confirm Deletion</h2>
				<p>
					Are you sure you want to delete <strong>{email}</strong>?
				</p>
				<div className="modal-actions">
					<button
						onClick={confirmDelete}
						className="confirm-btn"
					>
						Confirm
					</button>
					<button
						onClick={closeModal}
						className="cancel-btn"
					>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
};

export default ModalDeleteUser;
